import { render, staticRenderFns } from "./CompanyMarker.vue?vue&type=template&id=6afbcec9&"
import script from "./CompanyMarker.vue?vue&type=script&lang=js&"
export * from "./CompanyMarker.vue?vue&type=script&lang=js&"
import style0 from "./CompanyMarker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports